export const routeTitles = {
    // Dashboard
    "/dashboard/v1": "Tableau de bord - Swift",
    
    // Compta Factures
    "/comptabilite/factures": "Compta Factures - Swift",
    
    // Employees
    "/employees/employees": "Gestion du Personnel - Swift",
    
    // Documents
    "/Importation-doc": "Importation Documents - Swift",
    "/Document": "Mes Documents - Swift",
    
    // Comptabilité
    "/comptabilite/releve": "Importation Relevés - Swift",
    "/comptabilite/Operations": "Gestion Opérations - Swift",
    
    // Chat
    "/chat": "Swift Chat - Swift",
    
    // Clients
    "/clients/add": "Nouveau Client - Swift",
    "/clients": "Gestion des Clients - Swift",
    
    // Settings
    "/settings/information": "Identité et Contact - Swift",
    "/settings/AgenceInfo": "Information Agence - Swift",
    "/settings/preferences": "Préférences - Swift",
    "/settings/paiements": "Paiement - Swift",
    "/settings/theme": "Thème - Swift",
  };